import { render, staticRenderFns } from "./FeaturedProducts.vue?vue&type=template&id=17a98b94&scoped=true"
import script from "./FeaturedProducts.vue?vue&type=script&lang=js"
export * from "./FeaturedProducts.vue?vue&type=script&lang=js"
import style0 from "./FeaturedProducts.vue?vue&type=style&index=0&id=17a98b94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a98b94",
  null
  
)

export default component.exports